export default __webpack_public_path__ + "resmi_kaybetti.png";